import { render, staticRenderFns } from "./DefaultTitle.vue?vue&type=template&id=6e2ac296&scoped=true&"
import script from "./DefaultTitle.vue?vue&type=script&lang=js&"
export * from "./DefaultTitle.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTitle.vue?vue&type=style&index=0&id=6e2ac296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ac296",
  null
  
)

export default component.exports